import { render } from "./SectionWork.vue?vue&type=template&id=d0b330fc&scoped=true"
import script from "./SectionWork.vue?vue&type=script&lang=js"
export * from "./SectionWork.vue?vue&type=script&lang=js"

import "./SectionWork.vue?vue&type=style&index=0&id=d0b330fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b330fc"]])

export default __exports__